import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author VSm
 * @created on Dec 31 2019
 * @copyOf packages/common-be/src/data-processing/model/DpTaskConfig.ts
 */
import { DomainObject } from '@logio/common-be-fe';
export var DpTaskConfig =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DpTaskConfig, _DomainObject);

  function DpTaskConfig(id, type, attempts, timeout, prerequisites, cfg) {
    var _this;

    _classCallCheck(this, DpTaskConfig);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DpTaskConfig).call(this));
    _this.id = id;
    _this.type = type;
    _this.attempts = attempts;
    _this.timeout = timeout;
    _this.prerequisites = prerequisites;
    _this.cfg = cfg;
    return _this;
  }

  return DpTaskConfig;
}(DomainObject);